/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Quota_Week_Current_OneInputs */

const fr_calendar_quota_week_current_one = /** @type {(inputs: Calendar_Quota_Week_Current_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 séance restante cette semaine`)
};

/**

* @param {Calendar_Quota_Week_Current_OneInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_quota_week_current_one = /** @type {((inputs?: Calendar_Quota_Week_Current_OneInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Quota_Week_Current_OneInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_quota_week_current_one(inputs)
});